import React from 'react';

const NoLoyaltyProgram = () => (
  <div className="c-wrapper">
    <div className="u-max-width-710 u-margin-auto">
      <div className="c-inner-wrapper u-pt">
        Please set loyalty settings on the brand level.
      </div>
    </div>
  </div>
);

export default NoLoyaltyProgram;
